import { useTheme } from "@mui/material/styles";
import { CreditMenu, CreditMenuDark } from "components/icons";
import { useUserDataContext } from "context/UserDataContext";
import { getComponentByMode } from "utils";

import { StyledBadge } from "../BottomNavigation/styles";

interface IProps {
  size?: "small" | "normal";
}

const CreditBadge = ({ size = "normal" }: IProps) => {
  const theme = useTheme();
  const { creditsUnclaimed } = useUserDataContext();

  return (
    <StyledBadge
      badgeContent={creditsUnclaimed}
      invisible={!creditsUnclaimed}
      color="primary"
      max={Number.MAX_SAFE_INTEGER}
      size={size}>
      {getComponentByMode(theme, <CreditMenu color="inherit" />, <CreditMenuDark color="inherit" />)}
    </StyledBadge>
  );
};

export default CreditBadge;
